import { rectSortingStrategy } from '@dnd-kit/sortable';
import type { ComponentProps } from 'react';
import SortableContainers from './sortable/SortableContainers';
import {
  type TFormSubType,
  type TMultipleSelectOption,
  type TSingleSelectOption,
} from '@hubertai/screening-question-types';
// Base constraint: all sortable items must have at least an `id`
export type TSortableItemBase = { id: string };

// Specific types for each sortable item category
export type TTextBubbleItem = TSortableItemBase & { text: string | null };
export type TFormItem = TFormSubType;
export type TOptionItem = TSingleSelectOption | TMultipleSelectOption;

// Generic container item that accepts any item type extending the base
export type TSortableContainerItem<T extends TSortableItemBase = TSortableItemBase> = {
  id: string;
  headerName: string;
  items: T[];
  isDefault?: boolean;
};

export type TSortableInput<T extends TSortableItemBase = TSortableItemBase> = Record<
  string,
  TSortableContainerItem<T> | undefined
>;

interface Props extends ComponentProps<'div'> {
  // input: TSortableInput1
  input: TSortableInput;
  disabled?: boolean;
  onShouldUpdate?: (items: any, containers: string[]) => void;
  headerContent?: (data: any) => React.ReactNode;
  itemContent?: (data: any) => React.ReactNode;
}

const TextBubbleDragAndDrop = ({
  input,
  disabled = false,
  onShouldUpdate,
  headerContent,
  itemContent,
  ...props
}: Props) => {
  return (
    <div {...props}>
      {input ? (
        <SortableContainers
          itemCount={5}
          strategy={rectSortingStrategy}
          vertical
          items={input}
          handle={true}
          disabled={disabled}
          onShouldUpdate={onShouldUpdate}
          headerContent={headerContent}
          itemContent={itemContent}
          addContainer={{ enabled: false }}
        />
      ) : null}
    </div>
  );
};

export default TextBubbleDragAndDrop;
